import React from "react";
import { Flex, Spinner } from "@chakra-ui/react";
import vetspireLogo from "assets/vetspireLogo.svg";
import { Wrapper } from "components";
import { useAuth } from "duck";
import { useOrganizationQuery } from "requests";
import { IntegrationCard } from "./components";
import { useIntegrateVetspire } from "./duck";

const Integrations: React.FC = () => {
  const [{ user }] = useAuth();
  const { data, loading } = useOrganizationQuery({
    variables: {
      _id: user.organization?._id || 0
    }
  });
  const onVetspireIntegration = useIntegrateVetspire(
    user.organization?._id || 0
  );

  return (
    <Wrapper>
      {loading ? (
        <Flex justifyContent="center">
          <Spinner />
        </Flex>
      ) : (
        <Flex>
          <IntegrationCard
            defaultValues={{
              vetspireApiKey: data?.organization?.vetspireApiKey || ""
            }}
            serviceName="Vetspire"
            logo={vetspireLogo}
            onSubmit={onVetspireIntegration}
            inputName="vetspireApiKey"
          />
        </Flex>
      )}
    </Wrapper>
  );
};

export default Integrations;
